import PropTypes from 'prop-types';
// material
import { visuallyHidden } from '@material-ui/utils';
import { Box, Checkbox, TableRow, TableCell, TableHead, TableSortLabel, TablePagination, Typography, Stack } from '@material-ui/core';
import { useTheme, styled, alpha } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import { objectID } from '../../../../utils/objectID';

// ----------------------------------------------------------------------
const TableCellStyle = styled(TableCell)(({ theme }) => ({
    // height: 96,
    borderRight: "solid",
    //borderRightColor: `solid 2px ${alpha(theme.palette.primary.dark, 0.50)}`
    borderRightColor: theme.palette.mode === "light" ? "#fff" : theme.palette.grey[800],
    //background: theme.palette.mode === "light" ? "#DEDEEB" : theme.palette.grey[500_16]
}))
ContactListHead.propTypes = {
    order: PropTypes.oneOf(['asc', 'desc']),
    orderBy: PropTypes.string,
    rowCount: PropTypes.number,
    headLabel: PropTypes.array,
    numSelected: PropTypes.number,
    onRequestSort: PropTypes.func,
    onSelectAllClick: PropTypes.func
};

export default function ContactListHead({
    order,
    orderBy,
    rowCount,
    headLabel,
    numSelected,
    selected,
    contactList,
    page,
    onRequestSort,
    onSelectAllClick
}) {
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };
    const theme = useTheme();
    const { t } = useTranslation();
    const ids_contact = contactList.map((n) => objectID(n._id));
    const count_select_in_page = selected.filter((n) => ids_contact.includes(n));
    return (
        <TableHead>
            <TableRow>
                <TableCellStyle className="br_1" padding="checkbox">
                    <Stack direction={"row"} justifyContent={"center"} sx={{ mr: "10px" }}>
                        <Checkbox
                            indeterminate={numSelected > 0 && numSelected < rowCount}
                            checked={count_select_in_page.length === rowCount ? true : false}
                            onChange={onSelectAllClick}
                        />
                    </Stack>
                </TableCellStyle>
                {headLabel.map((headCell, index) => {
                    if (headCell.is_show_table) {
                        return <TableCellStyle
                            className="br_1"
                            key={index}
                            align="left"
                            sortDirection={orderBy === headCell.id ? order : false}
                        >
                            <TableSortLabel
                                hideSortIcon
                                active={orderBy === headCell.id}
                                direction={orderBy === headCell.id ? order : 'asc'}
                                onClick={createSortHandler(headCell.id)}
                            >
                                <Typography fontWeight={"bold"} sx={{ color: theme.palette.mode === "light" ? "black" : theme.palette.primary.secondary }}>  {t(headCell.field_name)} </Typography>
                                {orderBy === headCell.id ? (
                                    <Box sx={{ ...visuallyHidden }}>{order === 'desc' ? 'sorted descending' : 'sorted ascending'}</Box>
                                ) : null}
                            </TableSortLabel>
                        </TableCellStyle>
                    }

                })}
                <TableCellStyle align="center">
                    <Typography fontWeight={"bold"} sx={{ color: theme.palette.mode === "light" ? "black" : theme.palette.primary.secondary }}>Tác vụ</Typography>
                </TableCellStyle>

            </TableRow>
        </TableHead>
    );
}
